import React, { useCallback, useContext, useMemo } from 'react';
import classNames from 'classnames';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import RfiContext from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import ChooseTemplateModal from '../ChooseTemplateModal';
import { Button } from 'ncoded-component-library';
import { Link, useNavigate } from 'react-router-dom';
import { getDataRoomRoute } from 'utils';
import { useTranslation } from 'react-i18next';

import './CreateRfiActions.styles.scss';

type CreateRfiActionsProps = {
  className?: string;
};

const CreateRfiActions: React.FC<CreateRfiActionsProps> = (props) => {
  const { className } = props;

  const { rfiTemplates } = useContext(RfiContext);

  const {
    dataRoom: { _id: dataRoomId },
    doesntHaveAccess,
  } = useContext(DataRoomContext);

  const [chooseTemplateModal, chooseTemplateModalRef] =
    useCallbackRef<ModalRef>();

  const hasTemplates = useMemo(
    () => !!rfiTemplates.length,
    [rfiTemplates.length],
  );

  const classes = classNames('create-rfi-actions', className);

  const { t } = useTranslation();

  const navigate = useNavigate();

  const onCreateFromTemplate = useCallback(() => {
    if (!hasTemplates) return;

    if (rfiTemplates.length === 1) {
      navigate(
        `${getDataRoomRoute(dataRoomId, 'rfi/create')}/${rfiTemplates[0]._id}`,
      );
      return;
    }

    chooseTemplateModal?.open();
  }, [dataRoomId, hasTemplates, rfiTemplates, chooseTemplateModal, navigate]);

  if (doesntHaveAccess) return null;

  return (
    <div className={classes}>
      {hasTemplates && (
        <Button onClick={onCreateFromTemplate}>
          {t('createFromTemplate')}
        </Button>
      )}

      <Link to="../create" className="ncoded-button ncoded-button--solid">
        {t(hasTemplates ? 'createFromScratch' : 'createRequest')}
      </Link>

      <ChooseTemplateModal
        ref={chooseTemplateModalRef}
        dataRoomId={dataRoomId}
        rfiTemplates={rfiTemplates}
      />
    </div>
  );
};

export default CreateRfiActions;
